import { defineMessages } from 'react-intl';

export default defineMessages({
    priorMetPopupHeader: {
        id: 'ml.quoteandbind.priorMetPopup.We see you already have a policy with us, select the reason you are purchasing a new policy:',
        defaultMessage: 'We see you already have a policy with us, select the reason you are purchasing a new policy:',
    },
    sameLocationPriorMetTooltipContent: {
        id: 'ml.quoteandbind.priorMetPopup.sameLocationDiffCoverage',
        defaultMessage: 'You are purchasing a new policy for the same location but with different type of coverage.  For example, purchasing the home you were previously renting.',
    },
    sameLocationPriorMetTooltipTitle: {
        id: 'ml.quoteandbind.priorMetPopup.sameLocationPriorMetTooltipTitle',
        defaultMessage: 'What does this mean?'
    }
});
